import React, { useEffect, useState } from "react";
import showData from "../../Utils/APIs/getMethod";

const Index = () => {
  const [qcList, setQcList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const [openId, setOpenId] = useState(null);
  useEffect(() => {
    async function fetchData() {
      try {
        const result = await showData(
          `filedService/QC?page=${page}&limit=${limit}`,
        );

        setQcList(result?.data || []);
        setTotalPages(result?.totalPages || 1);
      } catch (error) {
        console.error("Error fetching QC:", error);
      }
    }

    fetchData();
  }, [page]);
  const toggleSurvey = (id) => {
    setOpenId(openId === id ? null : id);
  };
  return (
    <div className="overflow-auto h-[calc(100vh-8rem)]">
      <div className="max-w-7xl mx-auto p-4">
        <h2 className="text-3xl font-bold text-center mb-8">QC List</h2>

        {qcList.map((item) => (
        <div
          key={item._id}
          className="bg-white shadow-md rounded-xl p-6 mb-6 border"
        >
          {/* Farmer Info */}
          <div className="grid md:grid-cols-2 gap-4 mb-4">
            <div>
              <p className="text-xl font-semibold text-gray-800">
                {item.farmerId?.farmerName}
              </p>
              <p className="text-gray-600">
                Saral ID: {item.farmerId?.saralId}
              </p>
              <p className="text-gray-600">
                Contact: {item.farmerId?.contact}
              </p>
              <p className="text-gray-600">
                District: {item.farmerId?.district}
              </p>
            </div>

            <div className="text-sm text-gray-500 md:text-right">
              {new Date(item.createdAt).toLocaleString()}
            </div>
          </div>

          {/* Toggle Button */}
          <button
            onClick={() => toggleSurvey(item._id)}
            className="w-full flex justify-between items-center bg-blue-50 px-4 py-2 rounded-lg font-medium text-blue-700 hover:bg-blue-100 transition"
          >
            <span>Survey Questions</span>
            <span className="text-lg">
              {openId === item._id ? "▲" : "▼"}
            </span>
          </button>

          {/* Survey Section (Hidden by Default) */}
          {openId === item._id && (
            <div className="mt-4 grid sm:grid-cols-2 gap-4 animate-fadeIn">
              {item.SurveyData?.map((q) => (
                <div
                  key={q._id}
                  className="bg-gray-50 p-4 rounded-lg border"
                >
                  <p className="text-sm text-gray-700 mb-2">
                    {q.questionId?.question}
                  </p>

                  <span
                    className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${
                      q.answer
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {q.answer ? "Yes" : "No"}
                  </span>
                </div>
              ))}
            </div>
          )}

          {/* Images */}
          {item.SurveyImage?.length > 0 && (
            <div className="mt-6">
              <h4 className="font-semibold text-lg mb-3 text-gray-700">
                Images
              </h4>

              <div className="flex flex-wrap gap-4">
                {item.SurveyImage.map((img, index) => (
                  <img
                    key={index}
                    src={`${process.env.REACT_APP_SERVER_URL}${img}`}
                    alt="QC"
                    className="w-28 h-28 object-cover rounded-lg border hover:scale-105 transition duration-200 cursor-pointer"
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      ))}

      {/* Pagination */}
      <div className="flex justify-center items-center gap-6 mt-8">
        <button
          disabled={page === 1}
          onClick={() => setPage((prev) => prev - 1)}
          className="px-5 py-2 bg-blue-600 text-white rounded-lg disabled:bg-gray-400"
        >
          Prev
        </button>

        <span className="font-medium text-gray-700">
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage((prev) => prev + 1)}
          className="px-5 py-2 bg-blue-600 text-white rounded-lg disabled:bg-gray-400"
        >
          Next
        </button>
      </div>
    </div>
    </div>
  );
};

export default Index;
